<!-- eslint-disable vue/no-mutating-props -->
<template>



  <div class="nk-block-head">
    <div class="nk-block-head-content">
      <h5 class="nk-block-title" v-if="formIslem === 'ekle'">Yeni Rol  Ekle</h5>
      <h5 class="nk-block-title" v-if="formIslem === 'duzenle'">Rol  Düzenleme</h5>
      <div class="nk-block-des"><p>Roller</p></div>
    </div>
  </div>
  
  
    <form @submit.prevent="gonder">
  
      <div class="row">
     
      
          <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.ad }">
          <div class="col-lg-3">
            <label for="ad" class="form-label">Ad</label> 
          </div>
          <div class="col-lg-9">
          <input class="form-control"  id="ad" v-model="localFormData.ad" >
          <span v-if="formHatalar.ad" class="error">{{ formHatalar.ad }}</span>
          </div>
        </div>
      
      
      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.aciklama }">
          <div class="col-lg-3">
            <label for="aciklama" class="form-label">Açıklama</label> 
          </div>
          <div class="col-lg-9">
          <input class="form-control"  id="aciklama" v-model="localFormData.aciklama" >
          <span v-if="formHatalar.aciklama" class="error">{{ formHatalar.aciklama }}</span>
          </div>
        </div>
      
      
        <template v-for="yetki in yetkiler" :key="yetki.key">
       
          <div class="mb-1">{{yetki.ad}}</div>
      
  
          <div class="form-group">
            <div class="custom-control custom-checkbox checked">
              <input type="checkbox" class="custom-control-input"  
              :checked="localFormData.yetkiler.includes(`${yetki.key}_goster`)"
              @change="toggleYetki(yetki.key, 'goster')"
              :id="`${yetki.key}_checkGoster`">
              <label class="custom-control-label" :for="`${yetki.key}_checkGoster`" >Görüntüleyebilir</label>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox checked">
              <input type="checkbox" class="custom-control-input"  
              :checked="localFormData.yetkiler.includes(`${yetki.key}_ekle`)"
              @change="toggleYetki(yetki.key, 'ekle')"
              :id="`${yetki.key}_checkEkle`">
              <label class="custom-control-label" :for="`${yetki.key}_checkEkle`" >Ekleyebilir</label>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox checked">
              <input type="checkbox" class="custom-control-input"  
              :checked="localFormData.yetkiler.includes(`${yetki.key}_duzenle`)"
              @change="toggleYetki(yetki.key, 'duzenle')"
              :id="`${yetki.key}_checkDuzenle`">
              <label class="custom-control-label" :for="`${yetki.key}_checkDuzenle`" >Düzenleyebilir</label>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox checked">
              <input type="checkbox" class="custom-control-input"  
              :checked="localFormData.yetkiler.includes(`${yetki.key}_sil`)"
              @change="toggleYetki(yetki.key, 'sil')"
              :id="`${yetki.key}_checkSil`">
              <label class="custom-control-label" :for="`${yetki.key}_checkSil`" >Silebilir</label>
            </div>
          </div>
       
        
      </template>
      
      
      
      
      
      
      
      
  
       
      </div>
  
      
  
  
      <div class="d-flex justify-content-around  mt-4"> 
        
        <button type="button" class="btn btn-light  mr-2" @click="iptalEt"><em class="icon ni ni-cross"></em><span>İptal Et</span></button>
        <button type="submit" class="btn btn-primary"><em class="icon ni ni-check"></em><span>Kaydet</span></button>
      </div>
  
      
    </form>
  
  </template>
  
  <script>
  import axiosCustom from "@/services/axiosCustom";
  
  
  
  
  
  
  
  
  export default {
  components: {
    
    
    
    
    
    
  },
  props: {
    formIslem: String,
    formData: Object,
    formKaydetSonrasi: Function,
    formIptal: Function,
  
  },
  data() {
    return {
      
      yetkiler: [
            { key: 'kullanici', ad: 'Kullanıcılar' },
            { key: 'rol', ad: 'Roller' },
            { key: 'firma', ad: 'Firmalar' },
            { key: 'depertman', ad: 'Departmanlar' },
            { key: 'etkinlik', ad: 'Etkinlikler' },
            { key: 'kisi', ad: 'Kişiler' },
            { key: 'gorusmebilgi', ad: 'Görüşme Bilgileri' },
         
          ],
    
  
    
      localFormData: { ...this.formData }, 
      formHatalar:{},
  
      
  
    };
  },
  
  watch: {
        formData: {
          handler(newFormData) {
            this.localFormData = { ...newFormData };
  
            this.localFormData.yetkiler
            if(!this.localFormData.yetkiler){
              this.localFormData.yetkiler="";
            }
            
            
            
           
            
          },
          immediate: true, // Component oluşturulduğunda da tetikle
        },
      },
  methods: {
    
    
  
  
  
    formDogrula() {
      this.formHatalar = {};
      var kontrol=true;
      
      
      if (!this.localFormData.ad) {
        this.formHatalar.ad = "Ad boş bırakılamaz.";
        kontrol=false;
      }
      
      
    
     
    
    
    if (!this.localFormData.yetkiler) {
        this.formHatalar.yetkiler = "Yetkiler boş bırakılamaz.";
        kontrol=false;
      }
      
    
    
    
     
   
  
  
      return kontrol;
    },
    async  gonder() {
      if(this.formDogrula()){
    // FormData oluştur
    const newFormData = new FormData();
    newFormData.append("ad", this.localFormData.ad  ?? '');
    newFormData.append("aciklama", this.localFormData.aciklama ?? '');
    newFormData.append("yetkiler", this.localFormData.yetkiler ?? '');
    
    
     
    
    
  
    try {
    if (this.formIslem === "duzenle") {
      axiosCustom
        .post("roller/duzenle/" + this.localFormData.id, newFormData)
        .then(() => {
          
  
          this.$toast.success("Rol Düzenlendi");
          this.formKaydetSonrasi();
        })
        .catch((error) => {
          console.error("Güncelleme hatası: ", error);
          this.$toast.error("Güncelleme hatası");
        });
    } else {
      axiosCustom
        .post("roller/ekle", newFormData)
        .then(() => {
          
  
          this.$toast.success("Yeni Rol Eklendi");
          this.formKaydetSonrasi();
        })
        .catch((error) => {
          console.error("Ekleme hatası: ", error);
          this.$toast.error("Ekleme hatası");
        });
    }
  } catch (error) {
      console.error('Kaydetme hatası: ', error);
      this.$toast.error('Kaydetme hatası');
    }
  } 
    },
    
    iptalEt() {
      this.formIptal();
    },
  
    toggleYetki(key, yetki) {
          const yetkiString = `${key}_${yetki}`;
          const regex = new RegExp(`${yetkiString},?`);
  
          if (this.localFormData.yetkiler.match(regex)) {
            // Yetki zaten varsa kaldır
            this.localFormData.yetkiler = this.localFormData.yetkiler.replace(regex, '');
          } else {
            // Yetki yoksa ekle
            this.localFormData.yetkiler += `${yetkiString},`;
          }
        }
  
    
  },
  };
  </script>